const LT_CORAL_CART_PRODUCT_TAG = 'coral';
const ltCoralProductTagCache = new Map();
let ltCoralProgressUpdateTimeout;

function ltGetRouteRoot() {
  return window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';
}

function ltGetCartItemHandle(item) {
  if (item.handle) return item.handle;

  const itemUrl = item.url || item.product_url || '';
  const match = itemUrl.match(/\/products\/([^/?#]+)/);

  return match ? match[1] : '';
}

function ltGetCartItemLinePrice(item) {
  if (typeof item.final_line_price === 'number') return item.final_line_price;
  if (typeof item.line_price === 'number') return item.line_price;
  if (typeof item.final_price === 'number' && typeof item.quantity === 'number') return item.final_price * item.quantity;
  if (typeof item.price === 'number' && typeof item.quantity === 'number') return item.price * item.quantity;

  return 0;
}

async function ltProductHasCoralTag(handle) {
  if (!handle) return false;
  if (ltCoralProductTagCache.has(handle)) return ltCoralProductTagCache.get(handle);

  const response = await fetch(`${ltGetRouteRoot()}products/${handle}.js`);
  const product = await response.json();
  const hasCoralTag = Array.isArray(product.tags)
    ? product.tags.some((tag) => String(tag).toLowerCase() === LT_CORAL_CART_PRODUCT_TAG)
    : false;

  ltCoralProductTagCache.set(handle, hasCoralTag);

  return hasCoralTag;
}

function ltFormatMoney(cents) {
  if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
    return window.Shopify.formatMoney(cents);
  }

  return `$${(cents / 100).toFixed(2)}`;
}

function ltGetProgressTemplate(tracker, messageElement) {
  if (tracker.dataset.progressTemplate) return tracker.dataset.progressTemplate;

  const currentMessage = messageElement.textContent.trim();
  const template = currentMessage.match(/\$[\d,]+(?:\.\d{2})?/)
    ? currentMessage.replace(/\$[\d,]+(?:\.\d{2})?/, '[amount]')
    : "You're [amount] away from free shipping!";

  tracker.dataset.progressTemplate = template;

  return template;
}

function ltGetSuccessMessage(tracker, messageElement) {
  if (tracker.dataset.successMessage) return tracker.dataset.successMessage;

  const currentSuccess = messageElement.querySelector('[class*="__success-"]');
  const successMessage = currentSuccess ? currentSuccess.textContent.trim() : "You've unlocked free shipping!";
  tracker.dataset.successMessage = successMessage;

  return successMessage;
}

function ltGetScopedClass(tracker, prefix) {
  const rootClass = Array.from(tracker.classList).find((className) => className.startsWith('ai-free-shipping-progress-'));
  if (!rootClass) return '';

  return rootClass.replace('ai-free-shipping-progress-', prefix);
}

function ltUpdateFreeShippingTracker(tracker, coralCartTotal) {
  const threshold = Number(tracker.dataset.thresholdCents);
  const messageElement = tracker.querySelector('[data-message]');
  const barElement = tracker.querySelector('[data-bar]');

  if (!threshold || !messageElement) return;

  const remaining = threshold - coralCartTotal;
  const percentage = Math.min((coralCartTotal / threshold) * 100, 100);
  const successClass = ltGetScopedClass(tracker, 'ai-free-shipping-progress__success-');
  const completeClass = ltGetScopedClass(tracker, 'ai-free-shipping-progress__bar-fill--complete-');

  if (remaining <= 0) {
    messageElement.innerHTML = successClass
      ? `<span class="${successClass}">${ltGetSuccessMessage(tracker, messageElement)}</span>`
      : ltGetSuccessMessage(tracker, messageElement);
  } else {
    messageElement.textContent = ltGetProgressTemplate(tracker, messageElement).replace('[amount]', ltFormatMoney(remaining));
  }

  if (barElement) {
    barElement.style.width = `${percentage}%`;
    if (completeClass) barElement.classList.toggle(completeClass, remaining <= 0);
  }
}

async function ltUpdateCoralFreeShippingProgress() {
  const trackers = document.querySelectorAll('[data-threshold-cents][class*="ai-free-shipping-progress-"]');
  if (!trackers.length) return;

  try {
    const response = await fetch(`${ltGetRouteRoot()}cart.js?v=${Date.now()}`);
    const cart = await response.json();
    const coralCartTotal = (
      await Promise.all(
        (cart.items || []).map(async (item) => {
          const handle = ltGetCartItemHandle(item);
          const isCoralProduct = await ltProductHasCoralTag(handle);

          return isCoralProduct ? ltGetCartItemLinePrice(item) : 0;
        })
      )
    ).reduce((total, linePrice) => total + linePrice, 0);

    trackers.forEach((tracker) => ltUpdateFreeShippingTracker(tracker, coralCartTotal));
  } catch (error) {
    console.error('Error updating coral free shipping progress:', error);
  }
}

function ltScheduleCoralFreeShippingProgressUpdate(delay = 650) {
  clearTimeout(ltCoralProgressUpdateTimeout);
  ltCoralProgressUpdateTimeout = setTimeout(ltUpdateCoralFreeShippingProgress, delay);
}

window.addEventListener(PUB_SUB_EVENTS.cartUpdate, ltScheduleCoralFreeShippingProgressUpdate);
window.addEventListener('cart:updated', ltScheduleCoralFreeShippingProgressUpdate);
document.addEventListener('cart:updated', ltScheduleCoralFreeShippingProgressUpdate);
if (!window.ltaShippingCartFetchObserved) {
  window.ltaShippingCartFetchObserved = true;
  const originalFetch = window.fetch;
  window.fetch = async function (...args) {
    const response = await originalFetch.apply(this, args);
    const url = typeof args[0] === 'string' ? args[0] : args[0]?.url;
    if (response.ok && /\/cart\/(add|change|update|clear)(\.js)?(?:[?#]|$)/.test(url || '')) {
      ltScheduleCoralFreeShippingProgressUpdate(0);
    }
    return response;
  };
}
document.addEventListener('DOMContentLoaded', () => ltScheduleCoralFreeShippingProgressUpdate(0));

